import { apiPrefix, ConnectionService, httpMethodType } from "./Connecion.service";

const RESOURCE = 'auth/Store';

class AuthStoreTagService extends ConnectionService {

  constructor () {
    super();
    this.basedUrl = `${apiPrefix}/${RESOURCE}`;
  }

  async createSite (data) {
    const url = `${this.basedUrl}`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data)
    };
    return super.sendRequest(url, config, true);
  }

  async updateSite (siteId, data) {
    const url = `${this.basedUrl}/${siteId}`;
    const config = {
      method: httpMethodType.put,
      body: JSON.stringify(data)
    };
    return super.sendRequest(url, config, true);
  }

  async getSite (siteId) {
    const url = `${this.basedUrl}/${siteId}`;
    return super.sendRequest(url, {}, true);
  }

  async asyncDeleteTag (siteId) {
    const url = `${this.basedUrl}/${siteId}/asyncDelete`;
    const config = {
      method: httpMethodType.delete
    };
    return super.sendRequest(url, config, true);
  }

}

export default new AuthStoreTagService();